module.exports = __webpack_public_path__ + "img/cliente03.f79c90be.jpg";